
import './CtaBanner.css';

const CtaBanner = () => {
    return (
        <div className="cta-banner">
            <div className="cta-tag">Exploring Unique Properties in the Real Estate Market</div>
            <h2>Looking To Buy A Property?</h2>
            <div className="cta-actions">
                <div className="cta-phone">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.05 12.05 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.03 12.03 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <span>95148 96744</span>
                </div>
                <a href="#contact" className="cta-btn">Find Premium Property</a>
            </div>
        </div>
    );
};

export default CtaBanner;
